import { Owner } from "Store/interfaces/Owner";
import { Trafikkforsikringsavgift } from "Store/interfaces/Trafikkforsikringsavgift";
import { BaseStbRiskProduct } from "../BaseStbRiskProduct";

export interface BrandModelAndYear {
  readonly brand?: string;
  readonly model: string;
  readonly modelYear?: number;
}

export interface BaseVehicleProduct
  extends BaseStbRiskProduct,
    BrandModelAndYear {
  readonly licensePlateNumber?: string;
  readonly trafikkforsikringsavgift: Trafikkforsikringsavgift;
  readonly warrantyType: WarrantyType;
  readonly warrantyTypeFromTFF: WarrantyType;
  readonly insuranceHolderIsOwner: boolean;
  readonly owner: Owner;
}

export enum WarrantyType {
  UNCERTAINTY = "UNCERTAINTY",
  OWNER_CHANGE = "OWNER_CHANGE",
  COMPANY_CHANGE = "COMPANY_CHANGE",
}
